import { Component, HostListener, OnInit } from '@angular/core';
import { BreakpointService } from "../../services/breakpoint/breakpoint.service";

@Component({
    selector: 'say-breakpoint-helper',
    templateUrl: './breakpoint-helper.component.html',
    styleUrls: ['./breakpoint-helper.component.css']
})
export class BreakpointHelperComponent implements OnInit {

    constructor(private breakpointService: BreakpointService) {
    }

    ngOnInit() {
        this.breakpointService.onResize(window.innerWidth);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.breakpointService.onResize(event.target.innerWidth);
    }
}